<template>
  <div class="home">
    <the-navbar type="is-transparent" fixed-top/>
    <hero/>
    <section id="what">
      <div class="container">
        <div class="clear-100"></div>
        <p style="text-align: center">
          <img class="max-width-25pc" src="@/assets/img/logo.png" alt="">
        </p>
        <div class="clear-50"></div>
        <h1 style="text-align: center;">La plateforme qui simplifie les rendez-vous médicaux</h1>
        <div class="clear-30"></div>
        <p style="text-align: center; margin: 0 auto;" class="max-width-60pc">
          goMediCALest une suite d'application qui vous permet de gérer efficacement
          l'agenda de votre hopital:
          les <strong>prises de rendez-vous</strong>,
          les <strong>reports</strong>,
          les <strong>annulations</strong>
        </p>
        <div class="clear-100"></div>
      </div>
    </section>
    <div class="container" style="padding-top: 0px;">
      <div class="columns">
        <div class="column is-12 is-three-quarters-widescreen description-container">
          <div id="example-content">
            <template v-for="(section, index) in sections">
              <home-section
                :key="'section-' + index"
                :id="'section' + (index + 1)"
                :title="section.title"
                :description="section.description"
                :images="section.images"/>
              <div class="clear-100" :key="index"></div>
            </template>
          </div>
        </div>
        <div class="column sidebar-menu-container">
          <affix class="sidebar-menu" relative-element-selector="#example-content">
            <ul class="menu">
              <li class="header">Avant la consultation</li>
                <li><a href="#section1">Prise de rendez-vous</a></li>
                <li><a href="#section2">Paiement à distance</a></li>
                <li><a href="#section3">Notifications de rappel</a></li>

              <li class="header">Pendant la consultation</li>
                <li><a href="#section4">Accès au dossier médical</a></li>
                <li><a href="#section5">Constantes médicales</a></li>
                <li><a href="#section6">Ajout de prescriptions</a></li>

              <li class="header">Après la consultation</li>
                <li><a href="#prise-rendez-vous">Section 1</a></li>
                <li><a href="#prise-rendez-vous">Section 2</a></li>
                <li><a href="#prise-rendez-vous">Section 3</a></li>
            </ul>
          </affix>
        </div>
      </div>
    </div>
    <section id="join-now">
      <div class="container" style="text-align: center;">
        <div class="clear-100"></div>
        <div class="clear-50"></div>
        <h1>Rejoignez goMediCAL maintenant !</h1>
        <div class="clear-50"></div>
        <join-button/>
        <div class="clear-100"></div>
        <div class="clear-50"></div>
      </div>
    </section>
    <the-footer/>
  </div>
</template>

<script>
import TheNavbar from '@/components/TheNavbar'
import Hero from '@/components/HomeHero'
import JoinButton from '@/components/JoinButton'
import HomeSection from '@/components/HomeSection'
import TheFooter from '@/components/TheFooter'

export default {
  components: {
    Hero,
    TheNavbar,
    TheFooter,
    JoinButton,
    HomeSection
  },

  data () {
    return {
      sections: [{
        title: 'Prise de rendez-vous par l\'appli Patient',
        description: 'Désormais, vos patients peuvent reservez une consultation pour eux même ou pur un de leur proche simplement',
        images: [{
          src: require('@/assets/img/screens/appointment1.jpg'),
          width: 25
        }, {
          src: require('@/assets/img/screens/appointment2.jpg'),
          width: 25
        }]
      }, {
        title: 'Paiement par Mobile Money et carte bancaire',
        description: 'Permettez à vos patients de payer où de faire payer leur consultation par avance',
        images: [{
          src: require('@/assets/img/screens/appointment3.jpg'),
          width: 25
        }, {
          src: require('@/assets/img/screens/paymentlink.png'),
          width: 50
        }]
      }, {
        title: 'Notifications temps réel',
        description: 'Vos patients et médecins sont notifiés en temps réel via l\'application goMediCAL ou par SMS pour chaque action déterminante: report, annulation de rendez-vous',
        images: [{
          src: require('@/assets/img/screens/appointment1.jpg'),
          width: 25
        }, {
          src: require('@/assets/img/screens/appointment2.jpg'),
          width: 25
        }]
      }, {
        title: 'Consulter le dossier médical du patient',
        description: [
          'Pendant la consultation, vos médecins peuvent consulter le dossier médical du patient.',
          'Le dossier médical est privé. Seul le patient décide de le partager avec un médecin.'
        ],
        images: [{
          src: require('@/assets/img/screens/appointment1.jpg'),
          width: 25
        }, {
          src: require('@/assets/img/screens/appointment2.jpg'),
          width: 25
        }]
      }]
    }
  },

  mounted () {
    let menus = window.document.querySelectorAll('.menu > li > a')
    window.addEventListener('scroll', function () {
      const scrollTop = window.scrollY

      for (let i = 0; i < menus.length; i++) {
        const anchor = menus[i].href.substr(menus[i].href.indexOf('#'))
        const section = window.document.querySelector(anchor)

        if (
          section &&
          scrollTop > section.offsetTop - 200 &&
          scrollTop < section.offsetTop + section.offsetHeight - 70
        ) {
          menus[i].classList.add('is-active')
        } else {
          menus[i].classList.remove('is-active')
        }
      }
    })
  }
}
</script>

<style lang="scss">
  @import '../assets/sass/variables';

  .vue-affix {
    width: 100%;
    height: 100vh;
    display: flex;
    align-items: center;
  }

  .menu {
    margin-top: -30px;
    font-size: 0.8em;
    li {
      margin-bottom: 0.8rem;
      list-style-type: none;

      &.header {
        margin-top: 30px;
      }

      a {
        color: #a2aab3;

        &:before {
          display: inline-block;
          content: '';
          background-color: #e6e6e6;
          border-radius: 50%;
          display: inline-block;
          height: .5rem;
          margin-right: .5rem;
          margin-top: -1px;
          min-width: .5rem;
          width: .5rem;
        }

        &.is-active {
          color: $color-primary;
          font-weight: 700;

          &:before {
            background-color: $color-primary;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/index.vue